import React from 'react';
import {
  Modal,
  ModalSection,
  ModalHeader,
  ModalFooter,
  Button,
  Paragraph,
} from '@axiom/ui';
import type { FullCandidateAccount } from '@axiom/validation';

export type MyBenchHideShowCardConfirmModalProps = {
  candidate: FullCandidateAccount;
  onClose: (arg: boolean) => void;
  onSubmit: (arg: {
    isHiddenExternal: FullCandidateAccount['isHiddenExternal'];
  }) => void;
};

export const MyBenchCardHideShowConfirmModal = ({
  candidate,
  onClose,
  onSubmit,
}: MyBenchHideShowCardConfirmModalProps) => {
  return (
    <Modal name="SHOW_OR_HIDE_TALENT_DIALOG" size="confirm">
      <ModalHeader
        name="MODAL_HEADER"
        onClose={() => {
          onClose(false);
        }}
      >
        {candidate.isHiddenExternal
          ? 'Are you sure you want to show this talent on the client bench?'
          : 'Hide this talent from the client bench?'}
      </ModalHeader>
      <ModalSection>
        <Paragraph name="BODY_COPY">
          {candidate.isHiddenExternal
            ? `The client will be able to see ${candidate.calculatedDisplayName} on their bench.`
            : `The client will no longer be able to see ${candidate.calculatedDisplayName} on their bench.`}
        </Paragraph>
      </ModalSection>
      <ModalFooter>
        <Button
          name="CANCEL"
          variation="outline"
          onClick={() => {
            onClose(false);
          }}
        >
          Cancel
        </Button>
        <Button
          name="SUBMIT"
          onClick={() => {
            onSubmit({
              isHiddenExternal: !candidate.isHiddenExternal,
            });
          }}
        >
          {candidate.isHiddenExternal ? `Show on Bench` : `Hide from Bench`}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
